import { render } from "./AudienceDataOption.vue?vue&type=template&id=f937b890&scoped=true"
import script from "./AudienceDataOption.vue?vue&type=script&lang=js"
export * from "./AudienceDataOption.vue?vue&type=script&lang=js"

import "./AudienceDataOption.vue?vue&type=style&index=0&id=f937b890&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f937b890"]])

export default __exports__